import { createTheme } from '@mui/material/styles';
import { remCalc } from 'utils/remCalc';
import breakpoints from 'utils/breakpoints';
import mixins from 'utils/mixins';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const overrides = {
	'.curatedList__section': {
		...theme.mixins.layout_styles,
		'.curatedList__section_title_wrap': {
			'.curatedList__section_title': {
				textTransform: 'uppercase',
				textAlign: 'center',
				marginBottom: remCalc('32px'),
			}
		}
	}
}

const styles = {};

export default styles;